import { PencilIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ROUTES from '@/ROUTES'
import { format } from 'date-fns'

import { IProviderCategories } from '@/MODELS/providerCategories.model'
import { IPublicResource } from '@/MODELS/publicResource.model'

import { useResource } from '@/services/resource.service'

import AdminPageHeader from '@/components/AdminPageHeader'
import Button from '@/components/Button'
import ConfirmModal from '@/components/ConfirmModal'
import Table from '@/components/Table'

export default function AdminProviderCatTable() {
    const navigate = useNavigate()
    const [categories, setCategories, ResourceResource] = useResource<IProviderCategories[]>(
        ROUTES.admin.providerCategories
    )
    const [deleteResourceId, setDeleteResourceId] = useState<string | null>(null)

    return (
        <div className='flex flex-col w-full gap-5 py-10 mx-auto max-w-7xl'>
            <AdminPageHeader
                heading={'Providers Category Management'}
                subheading='Add, edit, and manage all published categories'
                className='py-5'
                action={<Button onClick={() => navigate('/admin/provider-category/new')}> Add Category </Button>}
            />
            <Table
                data={categories ?? []}
                columns={[
                    {
                        header: 'Name',
                        cell: 'name',
                    },
                    {
                        header: 'Description',
                        cell: (cat) => <div className='max-w-[250px] truncate'>{cat.description}</div>,
                    },

                    {
                        header: '',
                        cell: (cat) => (
                            <Link
                                to={`/admin/provider-category/${cat._id}`}
                                className='transition-opacity hover:opacity-70'
                                onClick={(e) => {
                                    e.stopPropagation()
                                }}
                            >
                                <PencilIcon className='w-6 h-6 shrink-0' />
                            </Link>
                        ),
                    },
                    {
                        header: '',
                        cell: (resource) => (
                            <>
                                <Button.Trash
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        console.log(resource._id)
                                        setDeleteResourceId(resource._id)
                                    }}
                                />
                            </>
                        ),
                    },
                ]}
            />

            <ConfirmModal
                open={!!deleteResourceId}
                onCancel={() => setDeleteResourceId(null)}
                onConfirm={async () => {
                    await ResourceResource.deleteById(deleteResourceId)
                    await ResourceResource.get()
                    setDeleteResourceId(null)
                }}
                title='Delete Category'
                description='Are you sure you want to delete this category? This action cannot be undone.'
                confirmText='Delete'
                cancelText='Cancel'
                intent='danger'
            />
        </div>
    )
}
